let swiperInstance;

function initSwiperIfMobile() {
  const container = document.querySelector('.image-collage__container');

  if (window.innerWidth < 768) {
    if (!swiperInstance && container.classList.contains('swiper')) {
      swiperInstance = new Swiper(container, {
        slidesPerView: 1.5,
        spaceBetween: 8,
        breakpoints: {
          375: {
            slidesPerView: 1.9,
            spaceBetween: 8,
          },
          480: {
            slidesPerView: 2.2,
            spaceBetween: 8,
          },
          640: {
            slidesPerView: 2.5,
            spaceBetween: 8,
          },
        },
        loop: false,
        navigation: {
          nextEl: '.carousel__slider-nav .swiper-button-next',
          prevEl: '.carousel__slider-nav .swiper-button-prev',
        },
      });
    }
  } else {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', initSwiperIfMobile);
window.addEventListener('resize', function () {
  clearTimeout(window.__swiperResizeTimeout);
  window.__swiperResizeTimeout = setTimeout(initSwiperIfMobile, 200);
});
